import React from "react";
import { Navigate } from "react-router-dom";
import PrivateLayout from "../layouts/private/Private";

let isLoggedIn = localStorage.getItem("token");

const PrivateRoute = (props) => (isLoggedIn ? <PrivateLayout {...props} /> : <Navigate to="/" />);

export default PrivateRoute;
